/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_TitleInputs */

const en_transcript_export_title = /** @type {(inputs: Transcript_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Transcription`)
};

const fr_transcript_export_title = /** @type {(inputs: Transcript_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter la transcription`)
};

const de_transcript_export_title = /** @type {(inputs: Transcript_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkription exportieren`)
};

const it_transcript_export_title = /** @type {(inputs: Transcript_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione della trascrizione`)
};

const ru_transcript_export_title = /** @type {(inputs: Transcript_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт транскрипции`)
};

const es_transcript_export_title = /** @type {(inputs: Transcript_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar transcripción`)
};

const zh_cn2_transcript_export_title = /** @type {(inputs: Transcript_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出转录`)
};

const ja_transcript_export_title = /** @type {(inputs: Transcript_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`転写のエクスポート`)
};

const hi_transcript_export_title = /** @type {(inputs: Transcript_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलेखन निर्यात करें`)
};

const pt_pt2_transcript_export_title = /** @type {(inputs: Transcript_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar transcrição`)
};

/**
* | output |
* | --- |
* | "Export Transcription" |
*
* @param {Transcript_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_title = /** @type {((inputs?: Transcript_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_title(inputs)
	if (locale === "de") return de_transcript_export_title(inputs)
	if (locale === "it") return it_transcript_export_title(inputs)
	if (locale === "ru") return ru_transcript_export_title(inputs)
	if (locale === "es") return es_transcript_export_title(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_title(inputs)
	if (locale === "ja") return ja_transcript_export_title(inputs)
	if (locale === "hi") return hi_transcript_export_title(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_title(inputs)
	return en_transcript_export_title(inputs)
});